import { render, staticRenderFns } from "./TravelProgrammingDetailForm.vue?vue&type=template&id=89e3cfae&scoped=true&"
import script from "./TravelProgrammingDetailForm.vue?vue&type=script&lang=js&"
export * from "./TravelProgrammingDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e3cfae",
  null
  
)

export default component.exports